module.exports = __webpack_public_path__ + "img/ico-pay-shouqianba.b4fea2b5.svg";